var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('NewAccountErrorTemplate',{attrs:{"title":_vm.title,"subtitle":_vm.subtitle,"onClose":_vm.onClose}})}
var staticRenderFns = []

export { render, staticRenderFns }